export default import.meta.ROLLUP_FILE_URL_M6e1V6AV6xtxXWLO3bjDTQ